import React from "react";
import { useNavigate, useLocation } from "react-router";
import ReactGA from "react-ga4";

import { SNETButton } from "shared/dist/components";
import { GlobalRoutes } from "../../../GlobalRouter/Routes";
import { GAEventsContent } from "../../../Services/Analytics/GAEvents";
import classes from "./LogAction.module.css";
import FAQLink from "../FAQLink";

const LoggedOutActions = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const continueButtonDetails = () => {
        if (location.pathname === GlobalRoutes.ENROLL.path) {
            return {
                children: "continue",
                onClick: () => {
                    ReactGA.event(GAEventsContent.HEADER_CONTINUE);
                    navigate(GlobalRoutes.SIGNUP.path);
                },
            };
        }
        return {
            children: "get started",
            onClick: () => {
                ReactGA.event(GAEventsContent.GET_STARTED_HEADER);
                navigate(GlobalRoutes.ENROLL.path);
            },
        };
    };

    return (
        <div className={classes.loggedActionsContainer}>
            <FAQLink />
            <SNETButton
                variant="outlined"
                children="login"
                color="primary"
                onClick={() => navigate(GlobalRoutes.LOGIN.path)}
            />
            <SNETButton variant="contained" {...continueButtonDetails()} />
        </div>
    );
};

export default LoggedOutActions;
